var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEdit1X(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "17px",
    viewBox: "0 0 16 17",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "708B20FA-BCF0-4718-9003-408815BCCDBD@1x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M15.7499546,3.58358353 L14.1249948,5.20836184 L10.7910562,1.87479577 L12.4160161,0.250017455 C12.7494099,-0.0833391518 13.3330726,-0.0833391518 13.6664665,0.250017455 L15.7499546,2.33327282 C16.0833485,2.66662943 16.0833485,3.25022692 15.7499546,3.58358353 Z M0,12.6664339 L9.83377791,2.83375459 L13.1677164,6.16732066 L3.33393852,16 L0,16 L0,12.6664339 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Project-Standards-View",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "General-PSView-Project-Main-V2-FMUnavailable",
    transform: "translate(-1055.000000, -302.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Module-/-Main-Info-/-FM-Status-/-PS-/-Unavailable",
    transform: "translate(66.000000, 254.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "FNMA-Approved-V2",
    transform: "translate(770.000000, 40.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Actions/edit",
    transform: "translate(219.000000, 8.300000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Icon/edit"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Icon-Color",
    fill: "#0C77BA",
    mask: "url(#mask-2)",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit1X);
export default __webpack_public_path__ + "static/media/edit@1x.3a3ebcac0aff23e5adf43d712b656404.svg";
export { ForwardRef as ReactComponent };